import { Signal } from "@/data/util/Signal";

import { BaseController } from "@/app/controller/BaseController";

export class OrderController extends BaseController {
    public onContinue?: { () };
    public onGoBack?: { () };
    public onShowServices?: { () };

    static onInit = new Signal();
    static onShown = new Signal();
    static onHidden = new Signal();

    static onContinue = new Signal();
    static onGoBack = new Signal();
    static onShowServices = new Signal();

    static onScrolled = new Signal();
    static onNotScrolled = new Signal();

    static onReset = new Signal();

    constructor() {
        super("order");

        OrderController.onContinue.add(this.continue, this);
        OrderController.onGoBack.add(this.goBack, this);
        OrderController.onShowServices.add(this.showServices, this);

        OrderController.onInit.dispatch();

        OrderController.onScrolled.add(this.onScrolled, this);
        OrderController.onNotScrolled.add(this.onNotScrolled, this);
    }

    protected onBecomeVisible(data?: { isMainNavigation: boolean; hasPreorderTimeStep?: boolean }) {
        OrderController.onShown.dispatch(data);
    }

    protected onBecomeInvisible() {
        OrderController.onHidden.dispatch();
    }

    public reset() {
        OrderController.onReset.dispatch();
    }

    protected showServices() {
        if (this.onShowServices) {
            this.onShowServices();
        }
    }

    protected goBack() {
        if (this.onGoBack) {
            this.onGoBack();
        }
    }

    protected continue() {
        if (this.onContinue) {
            this.onContinue();
        }
    }

    private onScrolled() {
        this.$view.addClass("scrolled");
    }

    private onNotScrolled() {
        this.$view.removeClass("scrolled");
    }
}
